import { render, staticRenderFns } from "./MeepIconNotificationMobile.vue?vue&type=template&id=22b07608"
import script from "./MeepIconNotificationMobile.vue?vue&type=script&lang=js"
export * from "./MeepIconNotificationMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports